module.exports = __webpack_public_path__ + "media/images/countryrect/ht-7f167a662754565361b91c75c04af231.svg";